import React from 'react';
import PropTypes from 'prop-types';

import Money from '../components/Money';

const Value = ({
  money,
  percent,
  children,
}) => {
  if (children) {
    if (money) {
      return <Money prefix="RM&nbsp;" fromCents amount={children} />;
    }
    if (percent) {
      return `${children} %`;
    }
    return children;
  }
  return 'N/A';
};

Value.propTypes = {
  money: PropTypes.bool,
  percent: PropTypes.bool,
  children: PropTypes.node,
};

Value.defaultProps = {
  money: false,
  percent: false,
  childrne: null,
};

export default Value;



// WEBPACK FOOTER //
// ./src/components/Value.jsx